<template>
    <div class="services-container">
        <div class="services">
            <div class="service" v-bind:key="i" v-for="(service, i) in services">
                <h3 class="title">
                    {{service.title}}
                </h3>
                <p v-bind:key="i" v-for="(s, i) in service.services">
                    {{s}}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"Services",
    data(){
        return{
            services:[
                {
                    title: 'Branding',
                    services: [
                        'Identity',
                        'Strategy',
                        'Style Guides',
                        'Logo Development'
                    ]
                },
                {
                    title: 'Video',
                    services: [
                        'Editing',
                        'Motion Graphics',
                        'Teaser Videos',
                        'Promotional GIFs'
                    ]
                },
                {
                    title: 'Web',
                    services: [
                        'Full Stack Development',
                        'SaaS Integrations',
                        'Wordpress',
                        'Local/Domestic Team',
                    ]
                },
                {
                    title: 'Social',
                    services: [
                        'Content Creation',
                        'Ads & Promos',
                        'Management',
                        'Channel/Page Branding'
                    ]
                },
                {
                    title: 'Print',
                    services: [
                        'Direct Mail ',
                        'Publication Ads',
                        'Custom Pieces',
                        'Coordination'
                    ]
                },
                {
                    title: 'Support',
                    services: [
                        'Web Management',
                        'On-Call',
                        'Fast Turnaround',
                        'White-Label Options'
                    ]
                },
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.services-container{
    margin: 52px 2rem 84px;
}
.services{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1210px;
    margin: 0 auto;
    text-align: center;
    .service{
        width: 33.33%;
        margin: 1rem 0;
        h3{
            margin-top: 2rem;
            margin-bottom: 1rem;
        }
        p{
            margin: 0;
        }
    }
}

@media (max-width: 769px) {
    .services{
        margin: 1rem 0;
        .service{
            margin: 0;
            padding: 0 1rem;
            width: 50%;
        }
    }
}

@media (max-width: $mobile) {
    .services-container{
        margin: 0;
    }
    .services{
        margin: 0;
        .service{
            margin: 41px 0 0;
            padding: 0;
            width: 100%;
            text-align: center;
        }
    }
}
</style>